module.exports = {"440404100":"三灶镇","440404101":"南水镇","440404103":"红旗镇","440404104":"平沙镇","440404400":"联港工业区","440404401":"航空产业园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440404.json
// module id = 1803
// module chunks = 0